/* HELDENA · glasservice-neu galeri v2.2 · 05.09.2026

   v2.2 · glasservice-neu-fix.css baglandi
     Ozellik kutularinda kelimeler ortadan boluniyordu ("Set-Größ / e").
     Sebep grid sutunlarinda 1fr kullanilmasi = minmax(auto,1fr), alt sinir
     min-content. "Spülmaschinengeeignet" gibi bolunemeyen uzun kelime sutunu
     iciyor, komsu sutun eziliyordu. Duzeltme ayri dosyada tutuluyor cunku
     glasservice-neu.css 16 KB - her kucuk duzeltme icin bastan yazmaya degmez.
     Buradan link edilir; sablona dokunulmaz.

   v2.1 · hero genisligi (1140px) + sol sutun doldurma (galfill)
   v2.0 · scrollIntoView dongusu kaldirildi; asil kaydirma engeli olan
          touch-action:pan-x ise glasservice-neu.css'te duzeltildi
*/
(function(){
  var root=document.getElementById('nkv1');if(!root)return;

  /* v2.2 · duzeltme stil dosyasi */
  (function linkFix(){
    if (document.getElementById('nk-fix-css')) return;
    var l=document.createElement('link');
    l.id='nk-fix-css';
    l.rel='stylesheet';
    l.href=window.__nkFixHref || '/cdn/shop/t/assets/glasservice-neu-fix.css';
    document.head.appendChild(l);
  })();

  /* ---------- duzen duzeltmeleri ---------- */
  (function injectStyle(){
    if (document.getElementById('nk-layout-fix')) return;
    var s=document.createElement('style');
    s.id='nk-layout-fix';
    s.textContent=
      '@media(min-width:901px){'+
        '#nkv1 .nk-hgrid{max-width:1140px;margin-left:auto;margin-right:auto;padding-left:24px;padding-right:24px}'+
        '#nkv1 .nk-hgrid>.nk-buy{max-width:640px}'+
      '}'+
      /* ozellik kutulari · kelime kirilmasini onle */
      '#nkv1 .nk-specs{grid-template-columns:repeat(4,minmax(0,1fr))}'+
      '@media(max-width:760px){#nkv1 .nk-specs{grid-template-columns:repeat(2,minmax(0,1fr))}}'+
      '@media(max-width:520px){#nkv1 .nk-specs{grid-template-columns:minmax(0,1fr)}}'+
      '#nkv1 .nk-whybuy{grid-template-columns:repeat(2,minmax(0,1fr))}'+
      '@media(max-width:640px){#nkv1 .nk-whybuy{grid-template-columns:minmax(0,1fr)}}'+
      '#nkv1 .nk-faq{grid-template-columns:repeat(2,minmax(0,1fr))}'+
      '@media(max-width:760px){#nkv1 .nk-faq{grid-template-columns:minmax(0,1fr)}}'+
      '#nkv1 .nk-trust{grid-template-columns:repeat(4,minmax(0,1fr))}'+
      '@media(max-width:600px){#nkv1 .nk-trust{grid-template-columns:repeat(2,minmax(0,1fr))}}'+
      '#nkv1 .nk-trustrepeat{grid-template-columns:repeat(4,minmax(0,1fr))}'+
      '@media(max-width:600px){#nkv1 .nk-trustrepeat{grid-template-columns:repeat(2,minmax(0,1fr))}}'+
      '#nkv1 .nk-offers{grid-template-columns:repeat(3,minmax(0,1fr))}'+
      '#nkv1 .nk-steps{grid-template-columns:repeat(3,minmax(0,1fr))}'+
      '@media(max-width:760px){#nkv1 .nk-steps{grid-template-columns:minmax(0,1fr)}}'+
      '#nkv1 .nk-spec,#nkv1 .nk-whybuy .w,#nkv1 .nk-trust>div,#nkv1 .nk-step{min-width:0}'+
      '#nkv1 .nk-spec h4,#nkv1 .nk-spec p,#nkv1 .nk-whybuy h3,#nkv1 .nk-whybuy p,'+
      '#nkv1 .nk-trust b,#nkv1 .nk-trust span,#nkv1 .nk-step h3,#nkv1 .nk-step p{'+
        'overflow-wrap:break-word;word-break:normal;hyphens:auto;-webkit-hyphens:auto}'+
      '#nkv1 .nk-spec h4{font-size:clamp(15px,1.4vw,19px);line-height:1.25}'+
      '#nkv1 .nk-spec p{font-size:clamp(12.5px,1.1vw,13.5px);line-height:1.5}'+
      '@media(max-width:520px){#nkv1 .nk-spec{padding:22px 20px}'+
        '#nkv1 .nk-spec h4{font-size:18px}#nkv1 .nk-spec p{font-size:14px}}'+
      /* galfill */
      '#nkv1 .nk-galfill{margin:16px 0 0;background:var(--paper2);border-radius:6px;overflow:hidden}'+
      '#nkv1 .nk-galfill img{width:100%;aspect-ratio:4/5;object-fit:contain;display:block;background:var(--paper2)}'+
      '#nkv1 .nk-galfill figcaption{padding:12px 16px 15px;font-size:13px;color:var(--muted);border-top:1px solid var(--line);line-height:1.5}'+
      '@media(max-width:900px){#nkv1 .nk-galfill{display:none}}';
    document.head.appendChild(s);
  })();

  /* ---------- ozellik kutularinda etiket tekrarini temizle ----------
     "Material: Glas – Transparentes Glas mit Fußform."
     "Reinigung: Spülmaschinengeeignet – Spülmaschinengeeignet."
     Deger metni etiketi tekrar ediyordu. Tekrar eden bas kismi kaldirilir.  */
  (function dedupeSpecs(){
    root.querySelectorAll('.nk-spec').forEach(function(box){
      var h=box.querySelector('h4'), p=box.querySelector('p');
      if(!h||!p) return;
      var txt=p.textContent.trim();
      var parts=txt.split(/\s+\u2013\s+/);            /* " – " ile ayir */
      if(parts.length<2) return;
      var first=parts[0].trim().replace(/\.$/,'');
      var rest=parts.slice(1).join(' \u2013 ').trim();
      /* iki parca ayni ise ya da ilk parca etiketi tekrarliyorsa sadeleştir */
      if(first.toLowerCase()===rest.replace(/\.$/,'').toLowerCase()){
        p.textContent=rest;
      }else if(rest.toLowerCase().indexOf(first.toLowerCase())===0){
        p.textContent=rest;
      }
    });
  })();

  var scrollEl=root.querySelector('#nkMainScroll');
  var slides=Array.prototype.slice.call(root.querySelectorAll('.nk-main-slide'));
  var thumbsEl=root.querySelector('#nkThumbs');
  var thumbs=Array.prototype.slice.call(root.querySelectorAll('#nkThumbs button'));
  var dotsEl=root.querySelector('#nkDots');

  (function galfill(){
    if (window.innerWidth < 901) return;
    var gal=root.querySelector('.nk-gallery'); if(!gal) return;
    if (gal.querySelector('.nk-galfill')) return;
    var imgs=root.querySelectorAll('.nk-main-slide img');
    if (imgs.length < 3) return;
    var src=imgs[2].getAttribute('src'); if(!src) return;
    var fig=document.createElement('figure');
    fig.className='nk-galfill';
    var im=document.createElement('img');
    im.src=src; im.alt=imgs[2].getAttribute('alt')||''; im.loading='lazy';
    fig.appendChild(im);
    if(im.alt){
      var cap=document.createElement('figcaption');
      cap.textContent=im.alt; fig.appendChild(cap);
    }
    gal.appendChild(fig);
  })();

  slides.forEach(function(s,i){
    var d=document.createElement('button');
    d.className='nk-dot'+(i===0?' active':'');
    d.setAttribute('data-idx',i);
    dotsEl.appendChild(d);
  });
  var dots=Array.prototype.slice.call(root.querySelectorAll('.nk-dot'));

  function setActive(idx){
    thumbs.forEach(function(t){t.classList.remove('active')});
    if(thumbs[idx]) thumbs[idx].classList.add('active');
    dots.forEach(function(d){d.classList.remove('active')});
    if(dots[idx]) dots[idx].classList.add('active');
  }
  function goTo(idx){
    if(!scrollEl || !slides[idx]) return;
    scrollEl.scrollTo({ left: slides[idx].offsetLeft, behavior:'smooth' });
  }
  function goToThumb(idx){
    if(!thumbsEl || !thumbs[idx]) return;
    var t=thumbs[idx];
    var target=t.offsetLeft - (thumbsEl.clientWidth - t.clientWidth)/2;
    if(target<0) target=0;
    thumbsEl.scrollTo({ left: target, behavior:'smooth' });
  }

  thumbs.forEach(function(t){
    t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-idx'),10)); });
  });
  dots.forEach(function(d){
    d.addEventListener('click', function(){ goTo(parseInt(d.getAttribute('data-idx'),10)); });
  });

  var syncing=false, syncTimer=null;
  function lockSync(){
    syncing=true; clearTimeout(syncTimer);
    syncTimer=setTimeout(function(){syncing=false;}, 700);
  }
  var userTouching=false;
  [scrollEl, thumbsEl].forEach(function(el){
    if(!el)return;
    el.addEventListener('pointerdown', function(){userTouching=true;});
  });
  window.addEventListener('pointerup', function(){
    setTimeout(function(){userTouching=false;}, 250);
  });

  if('IntersectionObserver' in window && scrollEl){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting && entry.intersectionRatio>0.6){
          var idx=slides.indexOf(entry.target);
          if(idx<0) return;
          setActive(idx);
          if(syncing) return;
          lockSync(); goToThumb(idx);
        }
      });
    },{root:scrollEl, threshold:[0.6]});
    slides.forEach(function(s){obs.observe(s);});
  }

  if('IntersectionObserver' in window && thumbsEl){
    var tobs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting && entry.intersectionRatio>0.6){
          var idx=thumbs.indexOf(entry.target);
          if(idx<0) return;
          if(syncing || userTouching) return;
          lockSync(); goTo(idx);
        }
      });
    },{root:thumbsEl, threshold:[0.6]});
    thumbs.forEach(function(t){tobs.observe(t);});
  }

  root.querySelectorAll('.nk-q>button').forEach(function(btn){
    btn.addEventListener('click',function(){
      var q=btn.parentElement, ans=q.querySelector('.ans');
      if(q.classList.contains('open')){q.classList.remove('open');ans.style.maxHeight=null;}
      else{q.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px';}
    });
  });

  root.querySelectorAll('.nk-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.nk-offer').forEach(function(x){x.classList.remove('active')});
      o.classList.add('active');
      var qi=root.querySelector('#nkQtyInput');
      if(qi)qi.value=o.getAttribute('data-qty');
    });
  });

  root.querySelectorAll('.nk-vpill').forEach(function(btn){
    btn.addEventListener('click', function(){
      root.querySelectorAll('.nk-vpill').forEach(function(b){b.classList.remove('active');});
      btn.classList.add('active');
      var vid = btn.getAttribute('data-variant-id');
      root.querySelectorAll('input[name="id"]').forEach(function(inp){ inp.value = vid; });
      var priceCents = Number(btn.getAttribute('data-price'));
      var priceStr = (priceCents/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' \u20ac';
      root.querySelectorAll('.nk-now').forEach(function(el){ el.textContent = priceStr; });
      var imgUrl = btn.getAttribute('data-image-url');
      if(imgUrl){
        var firstSlideImg = root.querySelector('.nk-main-slide img');
        if(firstSlideImg) firstSlideImg.src = imgUrl;
      }
    });
  });

  root.querySelectorAll('.nk-scrollwrap').forEach(function(wrap){
    var scroller = wrap.querySelector('.nk-moregallery');
    var hintRight = wrap.querySelector('.nk-scroll-hint:not(.nk-scroll-hint-left)');
    var hintLeft = wrap.querySelector('.nk-scroll-hint-left');
    if(!scroller || !hintRight) return;
    function checkHint(){
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if(maxScroll <= 4 || scroller.scrollLeft >= maxScroll - 4){ hintRight.classList.add('nk-hide'); }
      else { hintRight.classList.remove('nk-hide'); }
      if(hintLeft){
        if(maxScroll <= 4 || scroller.scrollLeft <= 4){ hintLeft.classList.add('nk-hide'); }
        else { hintLeft.classList.remove('nk-hide'); }
      }
    }
    checkHint();
    scroller.addEventListener('scroll', checkHint, { passive: true });
    window.addEventListener('resize', checkHint);
    scroller.querySelectorAll('img').forEach(function(im){
      if(im.complete) return;
      im.addEventListener('load', checkHint, {once:true});
    });
  });

  var st=root.querySelector('#nkSticky');
  if(st){
    window.addEventListener('scroll',function(){
      st.style.display = window.scrollY>700 ? 'flex' : 'none';
    },{passive:true});
  }
})();
